module.exports = __webpack_public_path__ + "img/6.c3a230b9.png";